<template>
  <div class="attendance-page">
    <!-- Vant Nav Bar -->
    <van-nav-bar title="考勤统计" left-text="返回" @click-left="goBack"/>

    <!-- 选项卡 -->
    <van-tabs v-model="tabActive" color="#1989fa">
      <van-tab title="日统计" name="daily">
        <van-field
            readonly
            clickable
            input-align="left"
            :value="formatDate(selectedDate)"
            @click="showDatePicker"
            :border="false"
        />
        <van-action-sheet v-model="showPicker" title="选择日期" :close-on-click-action="false">
          <!--          <div class="date-picker">-->
          <van-datetime-picker
              v-model="selectedDate"
              type="date"
              @confirm="onDateConfirm"
          />
          <!--          </div>-->
        </van-action-sheet>
        <!-- ECharts 统计 -->
        <div class="chart-container">
          <van-circle v-model="attendanceCount" :rate="0" :speed="100" size="120px"
                      :text="`今日打卡/总人数\n${attendanceCount}/${totalEmployees}`" layer-color="#eee"/>
        </div>
      </van-tab>

      <van-tab title="月统计" name="monthly">
        <!-- 月统计内容 -->
        <!-- 在这里添加月统计的内容 -->
      </van-tab>
    </van-tabs>

    <!-- 选项卡对应的员工信息 -->
    <div v-if="tabActive === 'daily'" class="attendance-info">
      <!-- 日统计内容 -->
      <div class="scrollable">
        <!-- 选项卡 -->
        <!--        <van-tabs v-model="tabActive1" color="#1989fa">-->
        <!--          <van-tab title="打卡" name="yes">-->
        <!-- 每个选项卡对应的员工列表 -->
        <div v-if="tabbarActive === 0" class="employee-list">
          <div v-for="(employee, index) in dailyEmployees" :key="index" class="employee-item">
            <div class="employee-info">
              <div class="employee-name">{{ employee.member_name }}</div>
              <div class="employee-position">{{ employee.dept_name }}</div>
            </div>
            <div class="last-check-in">最近打卡：{{ employee.lastCheckIn }}</div>
          </div>
        </div>
        <!-- 每个选项卡对应的员工列表 -->
        <div v-if="tabbarActive === 1" class="employee-list">
          <div v-for="(employee, index) in dailyEmployees2" :key="index" class="employee-item">
            <div class="employee-info">
              <div class="employee-name">{{ employee.member_name }}</div>
              <div class="employee-position">{{ employee.dept_name }}</div>
            </div>
            <div class="last-check-in">最近打卡：{{ employee.lastCheckIn }}</div>
          </div>
        </div>
        <!-- 每个选项卡对应的员工列表 -->
        <div v-if="tabbarActive === 2" class="employee-list">
          <div v-for="(employee, index) in dailyEmployees4" :key="index" class="employee-item">
            <div class="employee-info">
              <div class="employee-name">{{ employee.member_name }}</div>
              <div class="employee-position">{{ employee.dept_name }}</div>
            </div>
            <div class="last-check-in">最近打卡：{{ employee.lastCheckIn }}</div>
          </div>
        </div>
        <!-- 每个选项卡对应的员工列表 -->
        <div v-if="tabbarActive === 3" class="employee-list">
          <div v-for="(employee, index) in dailyEmployees6" :key="index" class="employee-item">
            <div class="employee-info">
              <div class="employee-name">{{ employee.member_name }}</div>
              <div class="employee-position">{{ employee.dept_name }}</div>
            </div>
            <div class="last-check-in">最近打卡：{{ employee.lastCheckIn }}</div>
          </div>
        </div>
        <!-- 每个选项卡对应的员工列表 -->
        <div v-if="tabbarActive === 4" class="employee-list">
          <div v-for="(employee, index) in dailyEmployees8" :key="index" class="employee-item">
            <div class="employee-info">
              <div class="employee-name">{{ employee.member_name }}</div>
              <div class="employee-position">{{ employee.dept_name }}</div>
            </div>
            <div class="last-check-in">最近打卡：{{ employee.lastCheckIn }}</div>
          </div>
        </div>

        <van-tabbar v-model="tabbarActive" active-color="#1989fa" class="custom-tabbar" @change="onChange">
          <van-tabbar-item icon="checked">白班上班</van-tabbar-item>
          <van-tabbar-item icon="close">白班下班</van-tabbar-item>
          <van-tabbar-item icon="clock">夜班上班</van-tabbar-item>
          <van-tabbar-item icon="underway">夜班下班</van-tabbar-item>
        </van-tabbar>
      </div>
    </div>
  </div>
</template>

<script>
import {getAll} from "@/api/performance";

export default {
  data() {
    return {
      DAY_SHIFT_START: 4,
      DAY_SHIFT_END: 6,
      DAY_SHIFT_START1: 18,
      DAY_SHIFT_END1: 20,
      NIGHT_SHIFT_START: 16,
      NIGHT_SHIFT_END: 18,
      NIGHT_SHIFT_START1: 6,
      NIGHT_SHIFT_END1: 8,
      selectedDate: new Date(),
      showPicker: false,
      tabActive: 'daily',
      // tabActive1: 'yes',
      tabbarActive: 0,
      attendanceCount: 0, // 今日打卡人数
      totalEmployees: 0, // 总人数,
      dailyEmployees: [],
      // dailyEmployees1: [],
      dailyEmployees2: [],
      // dailyEmployees3: [],
      dailyEmployees4: [],
      // dailyEmployees5: [],
      dailyEmployees6: [],
      // dailyEmployees7: [],
      dailyEmployees8: [],
    };
  },
  methods: {
    onChange(index) {
      if (index === 0) this.attendanceCount = this.dailyEmployees.length;
      if (index === 1) this.attendanceCount = this.dailyEmployees2.length;
      if (index === 2) this.attendanceCount = this.dailyEmployees4.length;
      if (index === 3) this.attendanceCount = this.dailyEmployees6.length;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const day = `${date.getDate()}`.padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    showDatePicker() {
      this.showPicker = true;
    },
    onDateConfirm(value) {
      this.dailyEmployees = []
      this.dailyEmployees2 = []
      this.dailyEmployees4 = []
      this.dailyEmployees6 = []
      this.dailyEmployees8 = []
      // 处理日期确认事件，你可以在这里更新数据或进行其他操作
      this.selectedDate = new Date(value)
      // this.selectedDate.setDate(this.selectedDate.getDate() - 1);
      this.showPicker = false // 关闭日期选择器
      this.loading()
    },
    goBack() {
      this.$router.go(-1)
    },
    getShiftType(a, date) {
      const DAY_SHIFT_START = 4;
      const DAY_SHIFT_END = 6;
      const DAY_SHIFT_START1 = 18;
      const DAY_SHIFT_END1 = 20;
      const NIGHT_SHIFT_START = 16;
      const NIGHT_SHIFT_END = 18;
      const NIGHT_SHIFT_START1 = 6;
      const NIGHT_SHIFT_END1 = 8;
      var records = a.daily_records
      var dayShiftCount = 0;
      var dayShiftCount1 = 0;
      var nightShiftCount = 0;
      var nightShiftCount1 = 0;
      var date = new Date(date)
      var hour = date.getHours();

      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();

      var todayDate = year + "" + (month < 10 ? "0" + month : month) + "" + (day < 10 ? "0" + day : day);

      date.setDate(date.getDate() - 1);
      year = date.getFullYear();
      month = date.getMonth() + 1;
      day = date.getDate();

      var previousDay = year + "" + (month < 10 ? "0" + month : month) + "" + (day < 10 ? "0" + day : day)

      if (!this.isToday(todayDate)) {
        hour = '11'
      }

      records.forEach((record) => {
        if (record.date === todayDate) {
          var checkinTimes = record.checkin_times
          var that = this
          checkinTimes.forEach(function (timestamp) {
            if (that.isInShift(timestamp, DAY_SHIFT_START, DAY_SHIFT_END)) {
              dayShiftCount++
            } else if (that.isInShift(timestamp, DAY_SHIFT_START1, DAY_SHIFT_END1)) {
              dayShiftCount1++
            } else if (hour < 12 && that.isInShift(timestamp, NIGHT_SHIFT_START1, NIGHT_SHIFT_END1)) {
              nightShiftCount1++
            } else if (hour >= 12 && that.isInShift(timestamp, NIGHT_SHIFT_START, NIGHT_SHIFT_END)) {
              nightShiftCount++
            }
          })
        } else if (previousDay === record.date) {
          var checkinTimes = record.checkin_times
          var that = this
          checkinTimes.forEach(function (timestamp) {
            if (hour < 12 && that.isInShift(timestamp, NIGHT_SHIFT_START, NIGHT_SHIFT_END)) {
              nightShiftCount++
            }
          })
        }


      })

      return [dayShiftCount, dayShiftCount1, nightShiftCount, nightShiftCount1];
    },
    isInShift(timestamp, startHour, endHour) {
      var date = new Date(parseInt(timestamp));
      var hour = date.getHours();
      return hour >= startHour && hour < endHour;
    },
    isToday(date) {
      var today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth() + 1;
      var day = today.getDate();

      var todayDate = year + "" + (month < 10 ? "0" + month : month) + "" + (day < 10 ? "0" + day : day);

      return date === todayDate;
    },
    isPreviousDay(date) {
      var today = new Date();
      today.setDate(today.getDate() - 1);
      var year = today.getFullYear();
      var month = today.getMonth() + 1;
      var day = today.getDate();

      var previousDay = year + "" + (month < 10 ? "0" + month : month) + "" + (day < 10 ? "0" + day : day)

      return date === previousDay;
    },
    loading() {
      // 格式化日期
      const formatter = new Intl.DateTimeFormat('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });

      getAll().then((response) => {
        this.totalEmployees = response.data.length
        // this.selectedDate.setDate(this.selectedDate.getDate() - 1);
        response.data.forEach((a) => {

          var shiftType = this.getShiftType(a, this.selectedDate);

          let b = a.daily_records.slice(-1)[0].checkin_times.slice(-1)[0]
          if (b !== undefined) {
            b = formatter.format(new Date(parseInt(b)))
          } else {
            b = a.daily_records[a.daily_records.length - 2].checkin_times.slice(-1)[0]
            if (b !== undefined) {
              b = formatter.format(new Date(parseInt(b)))
            } else {
              b = '无'
            }
          }

          // var date = new Date()
          // var hour = date.getHours()
          if (shiftType[0] >= 1) {
            this.dailyEmployees.push({"member_name": a.member_name, "dept_name": a.dept_name, lastCheckIn: b})
          } else if (shiftType[0] === 0) {
            // this.dailyEmployees1.push({"member_name": a.member_name, "dept_name": a.dept_name, lastCheckIn: b})
          }
          if (shiftType[1] >= 1) {
            this.dailyEmployees2.push({"member_name": a.member_name, "dept_name": a.dept_name, lastCheckIn: b})
          } else if (shiftType[1] === 0) {
            // this.dailyEmployees3.push({"member_name": a.member_name, "dept_name": a.dept_name, lastCheckIn: b})
          }

          if (shiftType[2] >= 1) {
            this.dailyEmployees4.push({"member_name": a.member_name, "dept_name": a.dept_name, lastCheckIn: b})
          } else if (shiftType[2] === 0) {
            // this.dailyEmployees5.push({"member_name": a.member_name, "dept_name": a.dept_name, lastCheckIn: b})
          }
          if (shiftType[3] >= 1) {
            this.dailyEmployees6.push({"member_name": a.member_name, "dept_name": a.dept_name, lastCheckIn: b})
          } else if (shiftType[3] === 0) {
            // this.dailyEmployees7.push({"member_name": a.member_name, "dept_name": a.dept_name, lastCheckIn: b})
          }
        })
        this.attendanceCount = this.dailyEmployees.length
      })
    }
  },
  mounted() {
    this.loading()
  }
};
</script>

<style>
.attendance-page {
  padding-bottom: 60px;
}

.chart-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.attendance-info {
  padding: 0 20px;
}

/* 调整选项卡大小 */
.van-tabbar.custom-tabbar {
  height: 75px !important;
}

.custom-tabbar .van-tabbar-item {
  font-size: 13px;
  height: 75px;
  line-height: 23px;
}

.employee-list {
  padding: 0 20px;
}

.employee-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 10px;
}

.employee-info {
  display: flex;
  align-items: center;
}

.employee-name {
  font-size: 18px;
  font-weight: bold;
  margin-right: 8px;
}

.employee-position {
  font-size: 14px;
  color: #999;
}

.last-check-in {
  font-size: 14px;
  color: #999;
}

.scrollable {
  height: calc(65vh - 150px); /* 调整滚动区域的高度 */
  overflow-y: auto;
  margin: 0 15px;
  border: 1px solid #ddd;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.content {
  padding: 16px 16px 160px;
}
</style>
